import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tabs = _resolveComponent("Tabs")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Tabs, {
      modelValue: $data.active,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.active) = $event)),
      class: "tabs",
      tabs: $data.tabs,
      bordered: "",
      "tab-position": "right"
    }, null, 8 /* PROPS */, ["modelValue", "tabs"]),
    ($data.active === 'system')
      ? (_openBlock(), _createBlock($setup["System"], { key: 0 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'pulse')
      ? (_openBlock(), _createBlock($setup["Pulse"], { key: 1 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'beta')
      ? (_openBlock(), _createBlock($setup["Beta"], { key: 2 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'scraping')
      ? (_openBlock(), _createBlock($setup["Scraping"], { key: 3 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'user-table')
      ? (_openBlock(), _createBlock($setup["UserTable"], { key: 4 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'tasks')
      ? (_openBlock(), _createBlock($setup["Tasks"], { key: 5 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'mongo')
      ? (_openBlock(), _createBlock($setup["Mongo"], { key: 6 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'weaviate')
      ? (_openBlock(), _createBlock($setup["Weaviate"], { key: 7 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'pulse-dashboard')
      ? (_openBlock(), _createBlock($setup["PulseDashboard"], { key: 8 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'test-skills')
      ? (_openBlock(), _createBlock($setup["TestSkills"], { key: 9 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'test-agents')
      ? (_openBlock(), _createBlock($setup["TestAgents"], { key: 10 }))
      : _createCommentVNode("v-if", true),
    ($data.active === 'test-tools')
      ? (_openBlock(), _createBlock($setup["TestTools"], { key: 11 }))
      : _createCommentVNode("v-if", true)
  ]))
}